import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
const InfoMation = resolve => require(['@/components/infomation'], resolve);
const HighAuction = resolve => require(['@/components/highAuction'], resolve);
const DarkAuction = resolve => require(['@/components/darkAuction'], resolve);
const Quotation = resolve => require(['@/components/quotation'], resolve);
const Basicinfo = resolve => require(['@/components/basicinfo'], resolve);

const warmTip = resolve => require(['@/components/contract/warmTip.vue'], resolve);
const sign = resolve => require(['@/components/contract/sign.vue'], resolve);
const shortMsg = resolve => require(['@/components/contract/shortMsg.vue'], resolve);
const detail = resolve => require(['@/components/contract/detail.vue'], resolve);
const suc = resolve => require(['@/components/contract/suc.vue'], resolve);
const cerror = resolve => require(['@/components/contract/error.vue'], resolve);

const valuation = resolve => require(['@/components/valuation/index.vue'], resolve);
const valuationConfig = resolve => require(['@/components/valuation/configureMessage.vue'], resolve);
const currentPurchasePrice = resolve => require(['@/components/valuation/currentPurchasePrice.vue'], resolve);
const curRetailPrice = resolve => require(['@/components/valuation/curRetailPrice.vue'], resolve);
const purchaseMarket = resolve => require(['@/components/valuation/purchaseMarket.vue'], resolve);
const retailMarket = resolve => require(['@/components/valuation/retailMarket.vue'], resolve);

const invatation = resolve => require(['@/components/invatation/index.vue'], resolve);
const invalid = resolve => require(['@/components/invatation/invalid.vue'], resolve);

const service = resolve => require(['@/components/terms/service.vue'], resolve);
const privacy = resolve => require(['@/components/terms/privacy.vue'], resolve);

const gmService = resolve => require(['@/components/gmTerms/gmService.vue'], resolve);
const gmPrivacy = resolve => require(['@/components/gmTerms/gmPrivacy.vue'], resolve);
const xiaolinggouService = resolve => require(['@/components/xiaolinggou/xiaolinggouService.vue'], resolve);
const xiaolinggouPrivacy = resolve => require(['@/components/xiaolinggou/xiaolinggouPrivacy.vue'], resolve);

const jlService = resolve => require(['@/components/jlTerms/jlService.vue'], resolve);
const jlPrivacy = resolve => require(['@/components/jlTerms/jlPrivacy.vue'], resolve);

const ugcService = resolve => require(['@/components/ugcTerms/ugcService.vue'], resolve);
const ugcPrivacy = resolve => require(['@/components/ugcTerms/ugcPrivacy.vue'], resolve);
const ycpService = resolve => require(['@/components/ycpTerms/ycpService.vue'], resolve);
const ycpPrivacy = resolve => require(['@/components/ycpTerms/ycpPrivacy.vue'], resolve);
const gypService = resolve => require(['@/components/gypTerms/gypService.vue'], resolve);
const gypPrivacy = resolve => require(['@/components/gypTerms/gypPrivacy.vue'], resolve);

const dafengche4sService = resolve => require(['@/components/dafengche4sTerms/dafengche4sService.vue'], resolve);
const dafengche4sPrivacy = resolve => require(['@/components/dafengche4sTerms/dafengche4sPrivacy.vue'], resolve);

const qiruiService = resolve => require(['@/components/qiruiTerms/qiruiService.vue'], resolve);
const qiruiPrivacy = resolve => require(['@/components/qiruiTerms/qiruiPrivacy.vue'], resolve);

const dadaopaiService = resolve => require(['@/components/dadaopaiTerms/dadaopaiService.vue'], resolve);
const dadaopaiPrivacy = resolve => require(['@/components/dadaopaiTerms/dadaopaiPrivacy.vue'], resolve);

const PDFViewer = resolve => require(['@/components/PDFViewer/index.vue'], resolve);

const purchaseClue = resolve => require(['@/components/purchaseClue'], resolve);
const blankPage = resolve => require(['@/components/blankPage'], resolve);

const assistant = resolve => require(['@/components/assistant'], resolve);
const auction = resolve => require(['@/components/auction/index.vue'], resolve);
const platform = resolve => require(['@/components/platform/index.vue'], resolve);
const huanche = resolve => require(['@/components/huanche/index.vue'], resolve);
const map = resolve => require(['@/components/map/index.vue'], resolve);
// const searchForm = resolve => require(['@/components/searchForm/searchForm.vue'], resolve);

const getVinCode = resolve => require(['@/components/codeRecognition/getVinCode.vue'], resolve);
const chooseCarModel = resolve => require(['@/components/codeRecognition/chooseCarModel.vue'], resolve);
const valuationSearchForm = resolve => require(['@/components/searchResult/searchResult.vue'], resolve);
const CitySelector = resolve => require(['@/components/citySelector/citySelector.vue'], resolve);
// const BrandSelector = resolve => require(['@/components/brandSelector/brandSelector.vue'], resolve);
import searchForm from '@/components/searchForm/searchForm.vue';
import BrandSelector from '@/components/brandSelector/brandSelector.vue';
import DownloadPage from '@/components/download/index.vue';
export const routerList = [
    // ios下载页面
    {
        path: '/static/download',
        name: 'DownloadPage',
        component: DownloadPage,
    },
    // 拍卖详情页面，入参：applyId,token
    {
        path: '/static/infomation',
        name: 'InfoMation',
        component: InfoMation,
    },
    // 高级批售版 拍卖详情  入参 token，auctionId:竞拍单ID roundId:场次ID  goodsId: 拍品ID

    {
        path: '/static/highAuction',
        name: 'HighAuction',
        component: HighAuction,
    },
    //估价结果页面 入参：modelCode  （车型code）、modelName （车型名称）、
    //licenseDate（首次上牌）、mileage（ 行驶里程）、cityCode  （城市code）、cityName  （城市名称）
    {
        path: '/h5Web/evaluation_common/searchResult',
        name: 'valuation',
        component: valuationSearchForm
    },
    //估价表单页面
    {
        path: '/h5Web/evaluation_common/searchForm',
        name: 'searchForm',
        component: searchForm,
        meta: {
            keepAlive: true,  // 需要缓存
            isBack: false,
        }
    },
    //选择城市
    {
        path: '/h5Web/evaluation_common/CitySelector',
        name: 'CitySelector',
        component: CitySelector
    },
    // 选择品牌
    {
        path: '/h5Web/evaluation_common/BrandSelector',
        name: 'BrandSelector',
        component: BrandSelector
    },
    // 选择VIN码识别
    {
        path: '/h5Web/evaluation_common/getVinCode',
        name: 'getVinCode',
        component: getVinCode
    },
    // 选择VIN码车型
    {
        path: '/h5Web/evaluation_common/chooseCarModel',
        name: 'chooseCarModel',
        component: chooseCarModel
    },
    // 暗拍 入参：applyId,token
    {
        path: '/static/darkAuction',
        name: 'DarkAuction',
        component: DarkAuction,
    },
    // 报价单 入参：reportCode（报告号）、platForm（平台）、price（参考价格）、now（时间戳）
    {
        path: '/static/quotation',
        name: 'Quotation',
        component: Quotation,
    },
    // 报价单-更多基本信息
    {
        path: '/static/basicinfo',
        name: 'Basicinfo',
        component: Basicinfo,
    },
    // 合同温馨提示 入参：contractNo(合同编号)、mobile(手机号)
    {
        path: '/static/contract/warmTip',
        name: 'warmTip',
        component: warmTip,
    },
    // 合同确认签署页面
    {
        path: '/static/contract/sign',
        name: 'sign',
        component: sign,
    },
    // 合同发送验证码
    {
        path: '/static/contract/shortMsg',
        name: 'shortMsg',
        component: shortMsg,
    },
    // 合同详情页面
    {
        path: '/static/contract/detail',
        name: 'detail',
        component: detail,
    },
    // 签署失败
    {
        path: '/static/contract/error',
        name: 'error',
        component: cerror,
    },
    // 签署成功
    {
        path: '/static/contract/suc',
        name: 'suc',
        component: suc,
    },
    // 估价结果页面 入参：modelCode  （车型code）、modelName （车型名称）、
    // licenseDate（首次上牌）、mileage（ 行驶里程）、cityCode  （城市code）、cityName  （城市名称）
    {
        path: '/static/valuation',
        name: 'valuation',
        component: valuation,
    },
    // 估价结果--配置项
    {
        path: '/static/valuation/carConfig',
        name: 'valuationConfig',
        component: valuationConfig,
    },
    // 估价结果--历史成交列表
    {
        path: '/static/valuation/currentPurchasePrice',
        name: 'currentPurchasePrice',
        component: currentPurchasePrice,
    },
    // 服务条款---吉利
    {
        path: '/static/jlService',
        name: 'jlService',
        component: jlService,
    },
    // 隐私协议---吉利
    {
        path: '/static/jlPrivacy',
        name: 'jlPrivacy',
        component: jlPrivacy,
    },
    // 估价结果--当前零售列表
    {
        path: '/static/valuation/curRetailPrice',
        name: 'curRetailPrice',
        component: curRetailPrice,
    },
    // 估价结果--采购行情列表
    {
        path: '/static/valuation/purchaseMarket',
        name: 'purchaseMarket',
        component: purchaseMarket,
    },
    // 估价结果--零售行情列表
    {
        path: '/static/valuation/retailMarket',
        name: 'retailMarket',
        component: retailMarket,
    },
    // 邀请短信链接
    {
        path: '/static/invatation',
        name: 'invatation',
        component: invatation,
    },
    // 短链失效
    {
        path: '/static/invalid',
        name: 'invalid',
        component: invalid,
    },
    // 服务条款
    {
        path: '/static/service',
        name: 'service',
        component: service,
    },
    // 隐私协议
    {
        path: '/static/privacy',
        name: 'privacy',
        component: privacy,
    },
    // 服务条款---广汽商贸
    {
        path: '/static/gmService',
        name: 'gmService',
        component: gmService,
    },
    // 隐私协议---广汽商贸
    {
        path: '/static/xiaolinggouPrivacy',
        name: 'xiaolinggouPrivacy',
        component: xiaolinggouPrivacy,
    },
    // 服务条款---广汽商贸
    {
        path: '/static/xiaolinggouService',
        name: 'xiaolinggouService',
        component: xiaolinggouService,
    },
    // 隐私协议---广汽商贸
    {
        path: '/static/gmPrivacy',
        name: 'gmPrivacy',
        component: gmPrivacy,
    },
    // 服务条款---ugc
    {
        path: '/static/ugcService',
        name: 'ugcService',
        component: ugcService,
    },
    // 隐私协议---ugc
    {
        path: '/static/ugcPrivacy',
        name: 'ugcPrivacy',
        component: ugcPrivacy,
    },
    // 服务条款---易诚拍
    {
        path: '/static/ycpService',
        name: 'ycpService',
        component: ycpService,
    },
    // 隐私协议---易诚拍
    {
        path: '/static/ycpPrivacy',
        name: 'ycpPrivacy',
        component: ycpPrivacy,
    },
    // 服务条款---广易拍
    {
        path: '/static/gypService',
        name: 'gypService',
        component: gypService,
    },
    // 隐私协议---广易拍
    {
        path: '/static/gypPrivacy',
        name: 'gypPrivacy',
        component: gypPrivacy,
    },
    // 服务条款---大风车4S
    {
        path: '/static/dafengche4sService',
        name: 'dafengche4sService',
        component: dafengche4sService,
    },
    // 隐私协议---大风车4S
    {
        path: '/static/dafengche4sPrivacy',
        name: 'dafengche4sPrivacy',
        component: dafengche4sPrivacy,
    },
    // 服务条款---奇瑞
    {
        path: '/static/qiruiService',
        name: 'qiruiService',
        component: qiruiService,
    },
    // 隐私协议---奇瑞
    {
        path: '/static/qiruiPrivacy',
        name: 'qiruiPrivacy',
        component: qiruiPrivacy,
    },
      // 服务条款---大道拍
      {
        path: '/static/dadaopaiService',
        name: 'dadaopaiService',
        component: dadaopaiService,
    },
    // 隐私协议---大道拍
    {
        path: '/static/dadaopaiPrivacy',
        name: 'dadaopaiPrivacy',
        component: dadaopaiPrivacy,
    },
    // 填写表单
    {
        path: '/static/purchaseClue',
        name: 'purchaseClue',
        component: purchaseClue,
    },
    // 线上助手
    {
        path: '/static/assistant',
        name: 'assistant',
        component: assistant,
    },
    // 拍卖
    {
        path: '/static/auction',
        name: 'auction',
        component: auction,
    },
    // 拍卖平台化
    {
        path: '/static/platform',
        name: 'platform',
        component: platform,
    },
    // 拍卖平台化
    {
        path: '/static/map',
        name: 'map',
        component: map,
    },
    // 暗拍toC
    {
        path: '/static/huanche',
        name: 'huanche',
        component: huanche,
    },
    // pdf阅览
    {
        path: '/static/pdfViewer',
        name: 'pdfViewer',
        component: PDFViewer,
    },
    // 空白页面
    {
        path: '/static/blankPage',
        name: 'blankPage',
        component: blankPage,
    }
]
export default new Router({
    routes: routerList
});



// WEBPACK FOOTER //
// ./src/router/index.js